<template>
    <div class="right author-right">
            <div class="chapter-title flexible aItem-center">
                <span v-for="(reward, index) in rewardList" :class="applyType == reward.applyType.value?'text-theme':'text-muted'" class="f-csp font-MT f20" @click="changeTab(index,reward.applyType.value)">
                    {{reward.applyType?reward.applyType.desc:''}}
                    <i class="line" v-if="applyType == reward.applyType.value"></i>
                </span>
            </div>
            <div class="reward-con">
                <chapter-tip v-for="(reward, index) in rewardList" v-if="applyType == reward.applyType.value">
                    <div slot="tip-con">
                        <img class="re-img2" :src="require(`@/assets/author/senLevel/re-${$i18n.locale}-img2.png`)" v-if="reward.applyType.value == 52"/>
                        <img class="re-img1" :src="require(`@/assets/author/senLevel/re-${$i18n.locale}-img1.png`)" v-if="reward.applyType.value == 50"/>
                        <div v-if="reward.applyType.value == 51&&$i18n.locale == 'en_US'">
                            You can apply for the Signing Bonus only when each signed novel reached {{bookdetail.first?'10k':'50k'}} words. The bonus will be added to your account later.
                        </div>
                        <div v-if="reward.applyType.value == 51&&$i18n.locale == 'en_ID'">
                            Jika setiap novel yang ditandatangani mencapai {{bookdetail.first?'10.000':'50.000'}} kata, Anda dapat mengajukan bonus penandatanganan. Bonus akan ditambahkan ke akun Anda nanti.
                        </div>
                    </div>
                    <div slot="tip-btn">
                        <div class="flexible aItem-center">
                            <!--申请完结-->
                            <el-button v-if="isSign && (!reward.applyDto||reward.applyDto && reward.applyDto.applyStatus == -2)" class="f16 font-MT" size="medium" @click="applyrewardFun(reward.applyType.value)"> {{$lang('authorCenter.stories.submit')}}</el-button>
                             <!--其它奖项-->
                           <el-button v-if="!isSign && (!reward.applyDto||reward.applyDto && reward.applyDto.applyStatus == -2)" class="f16 font-MT" type="info" size="medium" disabled>{{$lang('authorCenter.stories.submit')}}</el-button>
                            <el-popover
                                    placement="top"
                                    title=""
                                    width="280"
                                    popper-class="contract-pop"
                                    v-if="reward.applyDto && reward.applyDto.applyStatus == -2"
                                    trigger="hover"
                                    :content="reward.applyDto&&reward.applyDto.comment">
                                <i v-if="reward.applyDto && reward.applyDto.applyStatus == -2" slot="reference" class="el-icon-warning text-danger ml0" style="font-size: 25px;"></i>
                            </el-popover>
                        </div>
                        <el-button v-if="reward.applyDto&&reward.applyDto.applyStatus == 1" class="f16 font-MT" type="info" size="medium">{{$lang('authorCenter.stories.submitted')}}</el-button>
                        <el-button v-if="reward.applyDto && reward.applyDto.applyStatus == 2" class="f16 font-MT" type="success" size="medium">{{$lang('authorCenter.stories.success')}}</el-button>
                    </div>
                </chapter-tip>
            </div>
    </div>
</template>

<script>
    import {applyadd} from "apiurl/author"
    export default {
        name: "",
        data () {
            return{
                tabIndex: 0,
                applyType: 0,
                isSign: null,
                rewardList: [],
                words: 0,
            }
        },
        props: {
            bookdetail: Object,
        },
        watch: {
            bookdetail (n) {
                this.rewardList = this.bookdetail.rewardApply
                this.isSign = this.bookdetail.sign
                this.applyType = this.rewardList? this.rewardList[0].applyType.value:0
                this.words = this.bookdetail.words
            },
        },
        mounted() {
            this.rewardList = this.bookdetail.rewardApply
            this.isSign = this.bookdetail.sign
            this.applyType = this.rewardList? this.rewardList[0].applyType.value:0
            this.words = this.bookdetail.words
        },
        methods: {
            changeTab (index, type) {
                this.tabIndex = index
                this.applyType = type
            },
            applyrewardFun (flag) {
                this.applyType = flag;
                let params = {
                    bookId: this.$route.params.id,
                    applyType: this.applyType
                }
                applyadd(params).then(res=>{
                    if (res.success) {
                        this.$success('custom', 'Success！')
                        // let params = {
                        //     applyStatus: 1
                        // }
                        let el = this.rewardList[this.tabIndex]
                        if (!el.applyDto) {
                            el.applyDto = {}
                        }
                        this.$set(el.applyDto, 'applyStatus', 1)
                        this.$emit('changeChapter', '')
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .chapter-title{
        height: 90px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        border-radius: 16px 16px 0 0;
        span{
            display: inline-block;
            height: 90px;
            line-height: 90px;
            margin-right: 30px;
            position: relative;
            i{
                display: block;
                width: 50px;
                height: 6px;
                background: #FF049B;
                position: absolute;
                border-radius: 3px;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
            }
        }
        span:first-child{
            margin-left: 51px;
        }
    }
    .reward-con{
        /deep/.chapter-tip-title{
            display: none!important;
        }
    }
    .re-img1{
        height:166px;
        width: 494px;
    }
    .re-img2{
        height:316px;
        width: 1028px;
    }
</style>
<style lang="scss">
    .contract-pop{
        background: rgba(0,0,0,0.8)!important;
        color: #fff;
        font-size: 16px!important;
        font-family: Arial!important;
        line-height: 26px!important;
        border-radius: 12px!important;
        .popper__arrow,.popper__arrow::after{
            border-top-color: #000!important;
        }

    }
</style>
